import { useParams } from 'react-router-dom';

import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { SnapContributedOffers } from 'codegen';

import { columns } from './lib';

export const ContributedOffers = () => {
  const { snapId } = useParams();

  const { data, loading } = useGetRequest<SnapContributedOffers>({ url: `/snaps/${snapId}/offers` });

  return (
    <MilesTable
      horizontalScroll
      id='contributed-offers'
      loading={loading}
      columns={columns}
      dataSource={data?.contributedOffers}
    />
  );
};
